<template>
  <div id="maphome">
    <div id="headText">OpenLayers</div>
    <div id="mapcontent">
      <div id="map"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'mapUseOpenlayer',
    data() {
      return {

      }
    },
    computed: {},
    mounted() {
      this.initLeaflet();
    },
    watch: {},
    methods: {
      initLeaflet() {
        var map = new ol.Map({
          target: 'map',
          layers: [
            new ol.layer.Tile({
              source: new ol.source.OSM()
            })
          ],
          view: new ol.View({
            center: ol.proj.fromLonLat([37.41, 8.82]),
            zoom: 4
          })
        });
      },
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  #maphome {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url(../../../static/background.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    overflow-y: hidden;
  }

  #headText {
    color: white;
    margin: 50px;
    font-size: 20px;
  }

  #mapcontent {
    display: flex;
    justify-content: center;
  }

  #home-cartoon {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: -1;
  }

  #map {
    margin: 0 auto;
    height: 750px;
    width: 1200px;
    background: white;
  }

</style>



// WEBPACK FOOTER //
// mapUseOpenlayer.vue?9fd5b2f2